import React, { useState } from 'react';
import { Button, RadioGroup } from '@economic/taco';
import { Trans, t } from '@lingui/macro';
import ManWithABoxWareHouse from './man-with-a-box-in-a-warehause.svg';
import VismaEconomicLogo from './visma-economic-logo.svg';
import RackbeatLogo from './rackbeat-logo.svg';
import { Form } from '../../shared/components/Form';

interface Props {
    onDone: () => void;
    onSkip: () => void;
    setIsInterestedInRackbeat: (value: any) => void;
    isInterestedInRackbeat: boolean | undefined;
    children: string | JSX.Element;
}

export default function StepRackbeat({ children, onDone, onSkip, setIsInterestedInRackbeat, isInterestedInRackbeat }: Props) {
    const [showRackbeatError, setShowRackbeatError] = useState(false);

    const onFormSubmit = () => {
        if (isInterestedInRackbeat === undefined) {
            setShowRackbeatError(true);
            return;
        }
        onDone();
    };

    return (
        <div className="onboarding__container__fixed-size">
            <div className="onboarding text-center spa">
                <div className="flex flex-col">
                    <div className="flex justify-between">
                        <div className="flex ml-2">
                            <img src={VismaEconomicLogo} className="h-6" />
                        </div>
                        <div className="flex">
                            <div>
                                <img src={RackbeatLogo} className="h-6" />
                            </div>
                        </div>
                    </div>
                    <div className="mb-12">{children}</div>
                    <div className="mb-4">
                        <img src={ManWithABoxWareHouse} className="w-64 mx-auto" />
                    </div>
                    <h2 className="mb-4">
                        <Trans>Do you have items in stock?</Trans>
                    </h2>
                    <div className="mb-4">
                        <Trans>
                            With our storage solution, Storage by Rackbeat, you can manage your inventory together with your
                            accounts. Then you get a good overview and only have to type in one place. The figures from your
                            warehouse are transferred to the accounts automatically. In addition, you get…
                        </Trans>
                    </div>
                    <div className="flex space-x-2">
                        <p>
                            <strong>
                                <Trans>The strongest total accounting and inventory solution on the market</Trans>
                            </strong>
                        </p>
                        <p>
                            <strong>
                                <Trans>Specialized warehouse functions that can be adapted to your needs</Trans>
                            </strong>
                        </p>
                        <p>
                            <strong>
                                <Trans>Dedicated support to help with all your storage questions</Trans>
                            </strong>
                        </p>
                    </div>
                    <Form onSubmit={onFormSubmit}>
                        <div>
                            <RadioGroup
                                name="rackbeatRadio"
                                orientation="horizontal"
                                className="onboarding__radio-buttons"
                                value={isInterestedInRackbeat}
                                onChange={value => {
                                    setIsInterestedInRackbeat(value);
                                    setShowRackbeatError(false);
                                }}>
                                <RadioGroup.Item value={false}>{t`Contact me about my options`}</RadioGroup.Item>
                                <RadioGroup.Item value>{t`Go to Storage by Rackbeat`}</RadioGroup.Item>
                            </RadioGroup>
                            {showRackbeatError && (
                                <span
                                    className="h-4 text-xs text-left leading-normal font-normal truncate -mb-4 text-red-500"
                                    role="alert">
                                    Required
                                </span>
                            )}
                        </div>
                        <div className="onboarding__navigation-buttons">
                            <div className="onboarding__navigation-buttons">
                                <div className="onboarding__skip-step">
                                    <Button
                                        appearance="discrete"
                                        onClick={e => {
                                            e.preventDefault();
                                            onSkip();
                                        }}>
                                        <Trans>Skip</Trans>
                                    </Button>
                                </div>
                                <Button
                                    type="submit"
                                    appearance="primary"
                                    onClick={e => {
                                        if (isInterestedInRackbeat === undefined) {
                                            setShowRackbeatError(true);
                                            e.preventDefault();
                                        }
                                    }}>
                                    <Trans>Next</Trans>
                                </Button>
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        </div>
    );
}
